export * from './form-select-multiple.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/form-components/form-select-multiple/index.ts